import React from "react";
import { Link } from "react-router-dom";
import { Button, ContainedListItem, Layer, SkeletonText } from "@carbon/react";
import { ArrowRight, PinFilled } from "@carbon/react/icons";

import { useGetNewsQuery } from "@/redux/new_services/news";
import { Panel, PanelFooter, PanelHeader } from "../Panel/Panel";

import moment from "moment";
import "moment/locale/de";
moment.locale("de");

import "./news.scss";

// NewsPanel renders the latest visible news for the dashboard. The server
// already filters by user's organisation -> groups, so anything that arrives
// here is allowed to be shown. Items link to the dedicated detail page.
export const NewsPanel = () => {
  const { data: news = [], isFetching } = useGetNewsQuery();

  // Cap the panel at 6 items; anything older lives on /news.
  const items = news.slice(0, 6);

  return (
    <Panel>
      <PanelHeader header helpText="Aktuelle Mitteilungen">
        Neuigkeiten
      </PanelHeader>

      {isFetching && (
        <div style={{ padding: "0 1rem 1rem" }}>
          <SkeletonText paragraph lineCount={4} width="100%" />
        </div>
      )}

      {!isFetching && items.length === 0 && (
        <div className="news-panel-empty">
          <p>Aktuell liegen keine Neuigkeiten vor.</p>
        </div>
      )}

      {!isFetching && items.length > 0 && (
        <Layer level={1}>
          <div className="cds--contained-list cds--contained-list--on-page">
            {items.map((item) => {
              const teaserSrc =
                item.teaser_image?.s3_thumb_url ||
                item.teaser_image?.s3_med_url ||
                item.teaser_image?.s3_url ||
                null;
              return (
                <Link key={item.model.ID} to={`/news/${item.model.ID}`} className="news-panel-link">
                  <ContainedListItem>
                    <div className="news-panel-row">
                      {teaserSrc && (
                        <img
                          src={teaserSrc}
                          alt=""
                          className="news-panel-row__thumb"
                        />
                      )}
                      <div className="news-panel-row__body">
                        <div className="news-panel-row__head">
                          {item.is_pinned && <PinFilled size={12} className="news-panel-row__pin" />}
                          <span className="news-panel-row__title">{item.title}</span>
                        </div>
                        {item.excerpt && (
                          <p className="news-panel-row__excerpt">{item.excerpt}</p>
                        )}
                        <div className="news-panel-row__meta">
                          {item.published_at && moment(item.published_at).format("LL")}
                        </div>
                      </div>
                    </div>
                  </ContainedListItem>
                </Link>
              );
            })}
          </div>
        </Layer>
      )}

      <PanelFooter>
        <div className="panel-footer-link">
          <Button kind="ghost" size="sm" as={Link} to="/news" renderIcon={ArrowRight}>
            Alle Neuigkeiten ansehen
          </Button>
        </div>
      </PanelFooter>
    </Panel>
  );
};
